// Dedupes GET /catch-up across the catch-up widgets that mount together on the
// dashboard (CATCHUP_WIDGETS_PLAN.md Task 5): every widget calls
// getCatchUpData(patientId), but only the first triggers a real fetch — the rest
// join the same in-flight promise, so one dashboard load makes one call.

import type { CatchUpResponse } from "@medassist/shared";
import { getCatchUp } from "./api.js";
import { invalidateRead } from "./cache.js";

const inflight = new Map<string, Promise<CatchUpResponse>>();

export function getCatchUpData(patientId: string): Promise<CatchUpResponse> {
  const existing = inflight.get(patientId);
  if (existing) return existing;
  const promise = getCatchUp(patientId).finally(() => {
    if (inflight.get(patientId) === promise) inflight.delete(patientId);
  });
  inflight.set(patientId, promise);
  return promise;
}

/** Drop the cached/in-flight entry so the next mount refetches — called by the
 *  catch-up modals after a successful save. Clears both this module's in-flight
 *  map and the api-layer read cache (API_COLD_START_AND_REQUEST_FANOUT_PLAN.md
 *  Task 3.4) so the two caching layers can't diverge. */
export function invalidateCatchUp(patientId: string): void {
  inflight.delete(patientId);
  invalidateRead((key) => key.startsWith("/catch-up?"));
}
